import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Experience from '../components/Experience';
import Writeups from '../components/Blog';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-cyber-dark">
      <Header />
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Writeups />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage; 